// extracted by mini-css-extract-plugin
export default {"errorIdContainer":"error-boundary-modal__error-id-container__gpXNq"};